module.exports = __webpack_public_path__ + "static/e2ebranco-0e59d8bdeedb67f68fd3d64b8b487d33.png";